// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1SGLg","gfeWrapper":"CalendarEvent_gfeWrapper__1EjHe"};